var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgKnowledgeBase(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.08 10.352h-18A3.074 3.074 0 000 13.428V26.53a1.469 1.469 0 001.468 1.472H21.54a2.616 2.616 0 002.616-2.612V13.428a3.077 3.077 0 00-3.076-3.076z",
    fill: "#F2B77E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.424 0h12.064a2.304 2.304 0 012.304 2.304v21.043H3.116V2.304A2.305 2.305 0 015.424 0z",
    fill: "#E6F7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.152 3.11H6.476a1.5 1.5 0 00-1.5 1.5v20.35a1.5 1.5 0 001.5 1.5h13.676a1.5 1.5 0 001.5-1.5V4.61a1.5 1.5 0 00-1.5-1.5z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.692 2.324H21.2a1.6 1.6 0 011.6 1.6v21.752H6.112V3.904a1.6 1.6 0 011.58-1.58z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.692 2.871H21.2a1.6 1.6 0 011.6 1.6v21.747H6.112V4.451a1.6 1.6 0 011.58-1.58z",
    fill: "#F2FBFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.432 14.8H7.2a3.82 3.82 0 00-3.6 2.453L.068 26.627a1.012 1.012 0 00.944 1.376h20.22a3.575 3.575 0 003.344-2.313l3.32-8.78a1.568 1.568 0 00-1.464-2.11z",
    fill: "#FFD499"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.16 5.375H8.732a.628.628 0 000 1.256H20.16a.628.628 0 000-1.256zM20.16 8.797H8.732a.628.628 0 000 1.256H20.16a.628.628 0 000-1.256zM20.16 12.219H8.732a.628.628 0 000 1.256H20.16a.628.628 0 000-1.256z",
    fill: "#C3D9E6"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}
export default SvgKnowledgeBase;